import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 30 * 60 * 1000, // 30 min
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  },
});
